<section
	[editableInStoryblok]="_editable()"
	class="section-gap-wide section-spacing px-0"
	data-test-class="feature-split-section"
>
	@for (featureSplit of splits(); track featureSplit._uid; let odd = $odd) {
		<vp-feature-split
			[editableInStoryblok]="featureSplit._editable"
			[images]="featureSplit.photos"
			[inverse]="odd !== startInversed()"
		>
			<header>
				<h3
					class="heading-group font-display heading-group-lg heading-group-section"
				>
					{{ featureSplit.title }}
				</h3>
				<p class="heading-group-overline" role="doc-subtitle">
					{{ featureSplit.overline }}
				</p>
			</header>
			@for (blok of featureSplit.content; track $index) {
				<ndc-dynamic
					[ndcDynamicComponent]="components[blok.component]"
					[ndcDynamicInputs]="blok"
					class="hidden"
				/>
			}
		</vp-feature-split>
	}
</section>
